<div class="col" *ngIf="data!=null">
    <div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
        <ng-container *ngFor="let item of data; let i = index">
            <input type="radio" name="pcss3t"
                [(ngModel)]="tab" [value]="i" checked id="tab{{i}}">
            <label for="tab{{i}}">
                {{item.destination}}
            </label>
        </ng-container>

    </div>
    <div class="table-responsive" *ngFor="let item of data; let i = index">
        <table class="table  table-sm position-relative" [hidden]="tab!==i">
            <thead>
                <tr>
                    <th *ngFor="let col of columns"
                        [class.text-end]="col.align === 'end'">
                    {{ col.label }}
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let row of item.entries">
                    
                    <td *ngFor="let col of columns"
                        [class.text-end]="col.align === 'end'"
                        [class.fw-bold]="col.key === 'grossMargin'"
                        [class.text-danger]="col.key === 'grossMargin' && row[col.key] < 0"
                        [class.text-danger]="col.key === 'grossMarginPercent' && row[col.key] < 0">

                    <!-- TEXTO -->
                    <ng-container *ngIf="!col.format">
                        {{ row[col.key] }}
                    </ng-container>

                    <!-- ENTEROS -->
                    <ng-container *ngIf="col.format === 'int'">
                        {{ row[col.key] | number:'1.0-0' }}
                    </ng-container>

                    <!-- MONEDA 2 DECIMALES -->
                    <ng-container *ngIf="col.format === 'money'">
                        {{ row[col.key] | number:'1.2-2' }}
                    </ng-container>

                    <!-- MONEDA 4 DECIMALES -->
                    <ng-container *ngIf="col.format === 'money4'">
                        {{ row[col.key] | number:'1.2-4' }}
                    </ng-container>

                    <!-- PORCENTAJE -->
                    <ng-container *ngIf="col.format === 'percent'">
                        {{ row[col.key] | number:'1.2-4' }}%
                    </ng-container>

                    </td>

                </tr>
            </tbody>

        </table>
    </div>
</div>